import { CornerLeftUp } from "lucide-react"

import { Insignia } from "@/componentes/ui/Insignia"
import type { Tarea } from "./TarjetaTarea"

/**
 * De qué macro cuelga esta subtarea.
 *
 * ⚠ **Sin esto, una subtarea se lee como trabajo independiente.** Es lo que pasaba:
 * en el tablero y en su propia ficha, «Recoger los documentos en la aduana» y
 * «Llamar al cliente» parecían dos encargos sueltos, y quien coordina reparte dos
 * veces algo que ya tenía dueño. La dependencia va **arriba del todo**, antes que el
 * título: es lo primero que hay que saber para entender qué es esta tarea.
 *
 * ⚠ **Y es pulsable.** Enseñar el código de la macro sin poder ir a ella obliga a
 * buscarla a mano en el tablero, que es exactamente la fricción que hace que nadie
 * mire la dependencia.
 */

type Props = {
  padre: Tarea
  onAbrir: (id: number) => void
}

export function DependeDe({ padre, onAbrir }: Props) {
  return (
    <div
      data-testid="depende-de"
      className="mb-2 flex items-center gap-2 rounded-[var(--radius-control)] border border-dashed px-2 py-1.5"
      style={{ borderColor: "var(--border)" }}
    >
      <CornerLeftUp size={14} aria-hidden={true} style={{ color: "var(--fg-muted)" }} />
      <span className="text-xs" style={{ color: "var(--fg-muted)" }}>
        Depende de
      </span>
      <button
        type="button"
        onClick={() => onAbrir(padre.id)}
        className="min-w-0 flex-1 truncate text-left text-xs underline underline-offset-2"
      >
        <span className="tabular-nums">{padre.codigo}</span> · {padre.titulo}
      </button>
      <Insignia tono={padre.estado === "HECHA" ? "exito" : "neutro"}>
        {padre.estado.replaceAll("_", " ")}
      </Insignia>
    </div>
  )
}
